export interface TarifParType {
  typeId: string;
  typeNom: string;
  prix: number;
}

export interface PersonnelTailleur {
  id: string;
  nom: string;
  specialite: 'coupeur' | 'tailleur' | 'brodeur';
  telephone: string;
  tarifParCoupe: number;
  tarifParCouture: number;
  tarifsParType: TarifParType[];
  actif: boolean;
  commandesTotal: number;
  commandesMois: number;
  gainsMois: number;
}

export const personnelMock: PersonnelTailleur[] = [
  {
    id: 'pt1',
    nom: 'Ibrahim Traoré',
    specialite: 'coupeur',
    telephone: '+223 76 45 67 89',
    tarifParCoupe: 3500,
    tarifParCouture: 0,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 3500 },
      { typeId: 'th2', typeNom: 'Robe', prix: 3000 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 4000 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 4500 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 4000 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 5000 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 2000 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 1800 },
    ],
    actif: true,
    commandesTotal: 47,
    commandesMois: 8,
    gainsMois: 28000,
  },
  {
    id: 'pt2',
    nom: 'Seydou Coulibaly',
    specialite: 'coupeur',
    telephone: '+223 65 23 45 67',
    tarifParCoupe: 3000,
    tarifParCouture: 0,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 3000 },
      { typeId: 'th2', typeNom: 'Robe', prix: 2800 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 3500 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 3800 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 3500 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 4200 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 1800 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 1500 },
    ],
    actif: true,
    commandesTotal: 38,
    commandesMois: 6,
    gainsMois: 18000,
  },
  {
    id: 'pt3',
    nom: 'Moussa Diallo',
    specialite: 'tailleur',
    telephone: '+223 77 34 56 78',
    tarifParCoupe: 0,
    tarifParCouture: 8000,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 8000 },
      { typeId: 'th2', typeNom: 'Robe', prix: 7000 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 10000 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 12000 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 9000 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 15000 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 4000 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 3500 },
    ],
    actif: true,
    commandesTotal: 62,
    commandesMois: 10,
    gainsMois: 80000,
  },
  {
    id: 'pt4',
    nom: 'Boubacar Diarra',
    specialite: 'tailleur',
    telephone: '+223 74 56 78 90',
    tarifParCoupe: 0,
    tarifParCouture: 7500,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 7500 },
      { typeId: 'th2', typeNom: 'Robe', prix: 6500 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 9000 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 11000 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 8500 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 13000 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 3500 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 3000 },
    ],
    actif: true,
    commandesTotal: 55,
    commandesMois: 9,
    gainsMois: 67500,
  },
  {
    id: 'pt5',
    nom: 'Amadou Koné',
    specialite: 'tailleur',
    telephone: '+223 69 12 34 56',
    tarifParCoupe: 0,
    tarifParCouture: 6500,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 6500 },
      { typeId: 'th2', typeNom: 'Robe', prix: 5500 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 8000 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 9500 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 7500 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 11000 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 3000 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 2500 },
    ],
    actif: false,
    commandesTotal: 28,
    commandesMois: 0,
    gainsMois: 0,
  },
  {
    id: 'pt6',
    nom: 'Mamadou Sissoko',
    specialite: 'coupeur',
    telephone: '+223 78 99 11 22',
    tarifParCoupe: 2800,
    tarifParCouture: 0,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 2800 },
      { typeId: 'th2', typeNom: 'Robe', prix: 2500 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 3200 },
      { typeId: 'th4', typeNom: 'Ensemble 2 pièces', prix: 3500 },
      { typeId: 'th5', typeNom: 'Complet Homme', prix: 3000 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 3800 },
      { typeId: 'th7', typeNom: 'Chemise / Haut', prix: 1500 },
      { typeId: 'th8', typeNom: 'Jupe / Pagne', prix: 1200 },
    ],
    actif: true,
    commandesTotal: 21,
    commandesMois: 4,
    gainsMois: 11200,
  },
  {
    id: 'pt7',
    nom: 'Hawa Sangaré',
    specialite: 'brodeur',
    telephone: '+223 71 22 33 44',
    tarifParCoupe: 0,
    tarifParCouture: 0,
    tarifsParType: [
      { typeId: 'th1', typeNom: 'Boubou', prix: 5000 },
      { typeId: 'th3', typeNom: 'Kaftan', prix: 6000 },
      { typeId: 'th6', typeNom: 'Tenue Cérémonie', prix: 8000 },
    ],
    actif: true,
    commandesTotal: 15,
    commandesMois: 3,
    gainsMois: 15000,
  },
];
